import { useMemo } from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import SimpleTable from "../../../../../../components/SimpleTable";
import { renderUserName } from "../../../../../../utils/helpers/user";
import { cn } from "../../../../../../lib/utils";

const columnHelper = createColumnHelper();

function SuccessTable({ data, selectedUsers }: any) {
    const { t } = useTranslation();

    const columns = useMemo(() => [
        columnHelper.accessor("user", {
            header: t("user"),
            cell: ({ row: { original: { user } } }: any) => {
                return renderUserName(user);
            }
        }),
        columnHelper.accessor("message", {
            header: t("message"),
            cell: ({ row: { original: { message, status } } }: any) => {
                return (
                    <span className={cn(status ? "tw-text-green-700" : "tw-text-rose-500", "tw-text-sm")}>
                        {message}
                    </span>
                );
            }
        })
    ], [t]);

    const _data = useMemo(() => {
        return data?.map((item: any) => {
            const user = selectedUsers?.find((user: any) => user.id === item.user);
            return {
                ...item,
                user
            }
        })
    }, [selectedUsers, data]);

    return (
        <SimpleTable
            enableRowSelection={false}
            columns={columns}
            data={_data}
            footer={false}
            loading={undefined}
            getRowProps={undefined}
        />
    );
}

export default SuccessTable;
